// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleUnderline_title__cX4eL"};